var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topbar medhop-topbar"},[_c('NotificationCenter',{attrs:{"operational-signals":_vm.operationalSignals}}),_c('KTQuickUser')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }